import React, { Component } from "react";
import { hot } from "react-hot-loader";
import SVGInline from "react-svg-inline";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import queryString from "query-string";

import "./style.scss";

import ledger from "../../images/ledger.png";
import owe from "../../images/owe.png";
import accounts from "../../images/accounts.png";
import logo from "../../images/logo.png";
import spread from "../../images/spread.png";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      err: null,
      signedUp: false,
      emailAddress: null,
      refferEmail: null,
      fromAddress: null
    };
  }

  componentDidMount() {
    const parsed = queryString.parse(location.search);
    if (parsed.e) {
      this.setState({
        refferEmail: parsed.e
      });

      const user = {
        email: parsed.e,
        invited_by: parsed.f ? parsed.f : null
      };

      window.Intercom("update", user);
      window.history.replaceState(null, null, window.location.pathname);
    }
  }

  _onSubmit(e) {
    e.preventDefault();
    if (!validateEmail(this.refs.emailaddress.value)) {
      this.setState({
        err: "Please enter a valid email address."
      });
      return;
    } else {
      this.setState({
        err: null
      });
    }

    this.setState({
      signedUp: true,
      emailAddress: this.refs.emailaddress.value
    });

    const user = {
      email: this.refs.emailaddress.value
    };

    window.Intercom("update", user);

    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  render() {
    return (
      <div className="home">
        <div className="content-wrapper center">
          {this.state.refferEmail && (
            <div className="reffer" name="signup">
              <h2>Hello 👋</h2>
              <p>You've accepted your invitation!</p>
              <br />
              <p>
                {" "}
                We'll email you as soon as we're ready to set you up on toos.
              </p>
              <p>
                If you have any questions use the messenger in the bottom👇
                right of the screen to contact us.
              </p>
            </div>
          )}

          <div className={this.state.refferEmail ? "intro reffer" : "intro"}>
            <h2>Who pays for Netflix?</h2>
            <h3>
              A simple way to balance shared spending in your relationship.
            </h3>
            <p>
              toos is the easy way to organise and balance shared spending
              between couples. Things like rent, utility bills, drinks and
              holidays. No guessing, no spreadsheets, no shared bank account.
            </p>
          </div>

          <div className="features">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
              <div className="feat flip1">
                <img src={ledger} />
                <div>
                  <h3>Your shared spending history.</h3>
                  <p>
                    See who paid for what and how much it cost. Simply connect
                    your bank account and select the transactions which are
                    shared between you and your partner. In one glance see what
                    you and your partner have spent with each other.
                  </p>

                  <ul>
                    <li>
                      Only share the information you want. toos keeps your
                      balance, and income private. You only choose the
                      transactions you want to share.
                    </li>
                    <li>
                      Import transaction directly from your bank account. Select
                      shared transactions in a single tap.
                    </li>
                    <li>Keep track on what, and where, you spend.</li>
                  </ul>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
              <div className="feat flip2">
                <img src={owe} />
                <div>
                  <h3>Automatically see who owes what.</h3>
                  <p>
                    No more spreadsheets or pulling out the calculator. toos
                    keeps an ongoing balance so can you see exactly who owes
                    money, and who's waiting to be paid.
                  </p>
                  <ul>
                    <li>
                      Instantly see your financial position and be able to
                      budget with confidence.
                    </li>
                    <li>
                      Transfer money and settle the balance in a single tap.
                    </li>
                    <li>
                      Know exactly who paid for what. Make money arguments a
                      thing of the past.
                    </li>
                  </ul>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
              <div className="feat flip1">
                <img src={accounts} />
                <div>
                  <h3>Works with any two bank accounts.</h3>
                  <p>
                    Setting up a joint bank account usually means someone having
                    to join a new bank. With toos each user can be at different
                    banks - and pretty much any bank.
                  </p>
                  <p>
                    If things don't work out it's easy to separate your toos -
                    unlike a joint bank account!
                  </p>
                  <ul>
                    <li>
                      No need to move bank. Just connect your existing account.
                    </li>
                    <li>
                      Your bank information is 100% secure and kept private.
                    </li>
                    <li>
                      If you decide to part ways just settle up and disconnect
                      your account.
                    </li>
                  </ul>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
              <div className="feat flip2">
                <img src={spread} />
                <div>
                  <h3>A new way to manage.</h3>
                  <p>
                    No more spreadsheets, no more pulling out the calculator.
                    toos handles every aspect of your relationship finances
                    automatically.
                  </p>
                  <ul>
                    <li>Keeps you and your partner on the same page.</li>
                    <li>
                      No more logging in and out of multiple bank accounts.
                    </li>
                    <li>Transparency of information means less arguments.</li>
                  </ul>
                </div>
              </div>
            </ScrollAnimation>
          </div>

          {/* {!this.state.refferEmail && (
            <div className="sign-up" name="signup">
              <h3>Want to simplify your financial relationship?</h3>
              <p>Sign up to get first access to toos.</p>

              {!this.state.signedUp ? (
                <form onSubmit={this._onSubmit.bind(this)}>
                  <div>
                    <input
                      type="text"
                      placeholder="Your email address"
                      ref="emailaddress"
                    />
                    <button onClick={this._onSubmit.bind(this)}>
                      <span>Sign Up</span>
                    </button>
                  </div>
                </form>
              ) : (
                // <div>
                //   <a href="https://app.gettoos.com">
                //     <button>
                //       <span>Sign up</span>
                //     </button>
                //   </a>
                // </div>
                <div className="suc">
                  <h4>👍 Let's get started!</h4>
                  <button
                    onClick={() => {
                      this.props.history.push(
                        `/invite?e=${this.state.emailAddress}`
                      );
                    }}
                  >
                    <span>Get Started</span>
                  </button>
                </div>
              )}

              {this.state.err && <span className="err">{this.state.err}</span>}
            </div>
          )} */}
        </div>
      </div>
    );
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// /Users/grantmaclennan/code/_archive/Toos/src/pages/Home/index.js